import { Component, ViewChild, ViewContainerRef, ComponentRef, Injector } from "@angular/core";
declare const $;
import { BaseComponentWithDialog } from '../../admin-panel/base-admin-panel/base-component-with-dialog';
import { UsersService } from '../../../services/users.service';
import { JSProxyService } from '../../../services/jsproxy.service';

@Component({
    selector: 'app-right-track-base',
    template: '',
    standalone: false
})
export class RightComponentWithCollapsedPanel extends BaseComponentWithDialog {

  //usersService already exist in BaseComponentWithDialog
  // public usersService: UsersService;
  private jsProxyService: JSProxyService;
  public collapsed: boolean;
  public fullscreenmap: boolean;

  constructor(protected injector: Injector) {
    super(injector);
    this.jsProxyService = injector.get(JSProxyService);
    // this.usersService = injector.get(UsersService);

    this.fullscreenmap = true;
    this.collapsed = !this.fullscreenmap && this.jsProxyService.getVar("RightBottomPanel#Collapsed", false);
  }

  public splitterDown() {
    $(document).bind("mousemove", function (e: any) {
      document.getSelection().removeAllRanges();
      //debugger;
      var docH = $("body").height() || 0;

      var topright = e.clientY - 40;
      var bottomright = docH - topright;

      if (topright >= 72 && bottomright >= 125) {
        $("#topright").css("height", topright + "px");
        $("#bottomright_tables").css("height", "calc(100vh - " + (topright + 95) + "px)");
        $("#bottomright").removeClass("collapsed");
        $("#topright").removeClass("expanded");

        //$(window).trigger('resize');
      }
    });

    $(document).on("mouseup", function (e: any) {
      $(document).off("mousemove");
      $(document).off("mouseup");
    });
  }
  public collapseRightBottom() {

    this.collapsed = !this.collapsed;

    this.jsProxyService.setVar("RightBottomPanel#Collapsed", this.collapsed, false);
  }

}


@Component({
    selector: 'app-right-track',
    templateUrl: './right-track.component.html',
    styleUrls: ['./right-track.component.css'],
    standalone: false
})
export class RightTrackComponent extends RightComponentWithCollapsedPanel {

  constructor(protected injector: Injector) {
    super(injector);
  }
}
